import React from "react";

const TimerIcon = () => {
  return (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 4.5V8.5L10.6667 9.83333"
        stroke="#D19C2C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M8.00065 15.1693C11.6825 15.1693 14.6673 12.1845 14.6673 8.5026C14.6673 4.82071 11.6825 1.83594 8.00065 1.83594C4.31875 1.83594 1.33398 4.82071 1.33398 8.5026C1.33398 12.1845 4.31875 15.1693 8.00065 15.1693Z"
        stroke="#D19C2C"
        strokeWidth="1.3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default TimerIcon;
